import { Type } from 'class-transformer';
import {
	ArrayMaxSize,
	ArrayMinSize,
	IsArray,
	IsBoolean,
	IsEnum,
	IsOptional,
	IsUUID,
	ValidateNested,
} from 'class-validator';
import { TradePosition } from '../../enums';

export class BulkTradeItemDto {
	@IsUUID()
	marketId: string;

	@IsEnum(TradePosition)
	position: TradePosition;
}

export class MakeBulkTradesDto {
	@IsUUID()
	lobbyId: string;

	@IsArray()
	@ArrayMinSize(1)
	@ArrayMaxSize(100)
	@ValidateNested({ each: true })
	@Type(() => BulkTradeItemDto)
	trades: BulkTradeItemDto[];

	@IsOptional()
	@IsBoolean()
	isFirstMatchTrade?: boolean;
}

export class BulkTradeResultDto {
	placedMarketIds: string[];
	failedMarketIds: string[];
}
